import { baseUrl } from '../network'  

export const registerUrl = baseUrl + 'api/verification/email/send'
export const VerifyRegUrl = baseUrl + 'api/verification/email/verify'